/**
 * Created by zhaoyao on 19:45.
 * 充值详情界面
 */
import React from 'react';
import {Icon, Divider, Button} from "antd";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Toast } from "antd-mobile";

class SosPhone extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'RechargeDetail',
            data:{

            },
            IMEI: this.props.match.params.IMEI,
            relation: null,
            phone: null,
            relation1: null,
            phone1: null,
            relation2: null,
            phone2: null,
        };
    }


    componentDidMount(){
        Toast.loading('努力加载中...', 0)
       fetchGet(API.GET_SOS_PHONE,{
             IMEI: this.props.match.params.IMEI
       }).then((response)=>{
             Toast.hide()
                 console.log("response:"+JSON.stringify(response));
                 if(response.success){
                     this.setState({
                       relation:response.data.contacts,
                       phone:response.data.phone,
                       relation1:response.data.contacts1,
                       phone1:response.data.phone1,
                       relation2:response.data.contacts2,
                       phone2:response.data.phone2,
                     });
                 }
             }).catch((error)=>{
                Toast.hide()
                 console.log("error:"+JSON.stringify(error));
             })
    }

    render(){
        const {relation, phone, relation1, phone1, relation2, phone2} = this.state
        return <div className="padding_15" onChange={this.nicknameValueCom}>
        设置的SOS号码用于接收报警短信，以及一键求助时学生卡会依次给所设置的手机号拨打号码
                <div className="item_sty">
                    <div className="left_title">SOS号码1</div>
                    <input ref='phone' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.phone}/>
                </div>
                <div className="comhline_sty1"></div>
                <div className="item_sty">
                    <div className="left_title">SOS号码2</div>
                    <input ref='phone1' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.phone1}/>
                </div>
                <div className="comhline_sty1"></div>
                <div className="item_sty">
                    <div className="left_title">SOS号码3</div>
                    <input ref='phone2' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.phone2}/>
                </div>

                <div className="comhline_sty1"></div>
            <Button type="primary" block className='commonButton' style={{marginTop: '35px',borderRadius: '30px',}}
                                    onClick={this.bindSosPhone}>保存</Button>
        </div>
    }

    bindSosPhone = () => {
        Toast.loading('保存中...')
        const {IMEI, phone, phone1, phone2} = this.state

        const paramObj = {
            IMEI: IMEI,
            phone: phone,
            phone1: phone1,
            phone2: phone2
        }

        fetchPost(API.ADD_SOS_PHONE, {
            jsonAlbum: JSON.stringify(paramObj)
        }).then(response => {
            Toast.hide()
            this.backTask = setTimeout(() => {
                this.props.history.goBack();
            }, 1000)
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('保存失败')
            }
        })
    }

    nicknameValueCom = (event)=>{
        //获取用户名的值
        let phone = this.refs.phone.value;
        let phone1 = this.refs.phone1.value;
        let phone2 = this.refs.phone2.value;
        //获得内容的值
        this.setState({
            phone:phone,
            phone1:phone1,
            phone2:phone2,
        })
    }

}

export  default SosPhone;